import GenericCard from "@ui-components/Card/GenericCard";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import React from "react";


interface StatusEntry {
  status: number;
  text: string;
  createdAt: string;
}

interface StatusTableProps {
  data: StatusEntry[];
  headerContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  wrapperClassName?: string;
  /**
   * Width of the card itself. Defaults to three quarters, which suits the
   * detail page where this sits beside other content; a modal passes
   * `w-full` because there is nothing to sit beside and the extra quarter is
   * what pushed the row into horizontal scroll.
   */
  contentClassName?: string;
}

const statusVariantMap: Record<number, "success" | "neutral" | "warning"> = {
  2: "success",  // Finished
  1: "neutral",  // Active
  3: "warning",  // Pending
};

const StatusTable: React.FC<StatusTableProps> = ({
  data,
  headerContent = "Status",
  rightContent = "Date / Hour",
  wrapperClassName = "justify-start",
  contentClassName = "w-full md:w-3/4", }) => {
  return (
    <div className={`flex ${wrapperClassName} py-4`}>
      <div className={contentClassName}>
      <GenericCard
        isCollapsible={true}
        initialExpanded
        headerContent={headerContent}
        rightContent={rightContent}
        bodyContent={
          <div>
            {/* The row used to demand 500px and reserve 400 of them for the
                date, which is roughly twenty characters wide. In a modal that
                overflowed: a horizontal scrollbar appeared and the date was
                clipped mid-value ("03:0"). The date column now takes the width
                it needs and the label takes the rest. */}
            {data?.map((entry, itemIndex) => (
              <div key={itemIndex} className="flex flex-nowrap items-center gap-4 py-2 border-b last:border-0 w-full">
                <div className="flex-1 min-w-0">
                  <GenericTag minWidth="90px" label={String(entry.text)} variant={statusVariantMap[entry.status]} className="whitespace-nowrap" />
                </div>
                <div className="flex-shrink-0 text-right">
                  <p className="text-sm text-semantic-text-secondary whitespace-nowrap text-right">
                    {new Date(entry.createdAt).toLocaleString("es-MX", {
                      day:   "2-digit",
                      month: "2-digit",
                      year:  "numeric",
                      hour:   "2-digit",
                      minute: "2-digit",
                      hour12: false,
                      timeZone: "America/Mexico_City",
                      timeZoneName: "short"
                    })}
                  </p>
                </div>
             </div>
             
            ))}
          </div>
        }
      />
      </div>
    </div>
  );
};

export default StatusTable;

